<template>
  <div class="source-sans-pro">
    <!-- {{fields}}{{items}} -->
    <span v-if="tableView == 'normalView'">
      <b-table
        :items="items"
        class="rating-remarks"
        :bordered="true"
        :fields="fields"
        fixed
        outlined
      >
        <template v-slot:cell(RESPONSE)="row">
          <span
            :class="row.item.RESPONSE == 'Satisfied' ? 'green-text' : 'red-text'"
          >{{row.item.RESPONSE}}</span>
        </template>
        <template slot="RATING" slot-scope="row">
          <span class="rating-text">{{row.item.RATING}}</span>
        </template>
        <template class="p-0 m-0" v-slot:cell(REMARKS)="row">
          <div class="remarks-value p-0 m-0">
            <span v-if="row.item.REMARKS.length  <= 15">{{row.item.REMARKS}}</span>
            <span v-else>
              <span>{{row.item.REMARKS | remarksText}}</span>
              <span
                class="pl-3 viewmore"
                v-b-popover.hover.bottomleft="row.item.REMARKS"
                variant="primary"
              >Read More</span>
            </span>
          </div>
        </template>
        <template class="m-0" v-slot:cell(ATTACHMENT)="row">
          <!-- <a
            @click="downloadAttachment(row.item.ATTACHMENT)"
            href="#"
          >{{getAttachmentName(row.item.ATTACHMENT)}}</a>-->
          <img
            v-if="row.item.ATTACHMENT"
            src="@/assets/images/clip.svg"
            @click="downloadAttachment(row.item.ATTACHMENT)"
            class="cursor-pointer uploaded-image"
            data-toggle="tooltip"
            data-placement="left"
            animation="true"
            :title="row.item.ATTACHMENT != null ? 'Download Attachment':'No attachment uploaded'"
          />
          <span v-else>-</span>
        </template>
      </b-table>
    </span>
  </div>
</template>

<script>
import { SummaryServices } from "../services/summaryService";
const SummaryService = new SummaryServices();
export default {
  components: {},
  props: ["items", "fields", "tableView"],

  data() {
    return {
      itemValue: []
    };
  },
  //   watch: {
  //     items: function() {
  //       var theData = {
  //         somevar: this.messageId
  //         // other object attributes
  //       };

  //       return theData;
  //       console.log(theData);
  //     }
  //     // items: function(value) {
  //     //   this.itemValue = value;
  //     //   console.log(this.itemValue);
  //     // }
  //   },
  created() {
    // this.getItemValue();
  },
  filters: {
    remarksText: function(string) {
      return string.substring(0, 30) + "...";
    }
  },
  methods: {
    getAttachmentName(attachment) {
      if (attachment) {
        return attachment.split(/_(.+)/)[1];
      } else {
        return "-";
      }
    },
    downloadAttachment(event) {
      if (event) {
        this.loading = true;
        SummaryService.downLoadDocument(event).then(res => {
          this.loading = false;
        });
      }
    }
    // getItemValue() {
    //   console.log(this.items);
    //   this.items.forEach(element => {
    //     if (element.RESPONSE === "Satisfied") {
    //     }
    //   });
    // }
  }
};
</script>

<style>
.thClass {
  background-color: #6192b1 !important;
  color: white;
  text-align: left !important;
}
/* .table {
  color: #212529;
  background-color: #ffffff;
  text-align: left;
  margin-right: 5%;
} */
.table thead th {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.18px;
  background-color: #6192b1 !important;
  color: white;
  text-align: left !important;
}
.rating-remarks {
  max-height: 10vh !important;
  overflow: auto;
  text-align: left;
  /* background-color: #6192b1 !important; */

  /* text-align: justify; */
  /* color: red; */
}
.green-text {
  color: #00b998;
  font-weight: 600;
  width: 10%;
}
.red-text {
  color: #e74c3c;
  font-weight: 600;
  width: 10%;
}
.rating-text {
  text-align: right;
}
.minremarks {
  width: 15% !important;
}
.popOverRemarks {
  /* cursor: pointer;
  font-size: 12px;
  color: #747474;
  text-decoration: underline;
  outline: none !important; */
}
.uploaded-image {
  margin-left: auto;
  margin-right: auto;
  display: block;
}
</style>

